/* eslint-disable valid-typeof */
import { useQuery } from '@tanstack/react-query';
import useJwt from '../../utils/useJwt';

export interface PlacesFilter {
  placeId?: string;
}

export type PlacesDetailsResponse = {
  city: string[];
  postcode: string[];
  countryCode: string;
};

export type PlacesDetailsErrorResponse = {
  code: number;
  data: {
    cause: string;
    context: {
      countryCode: string;
    };
  };
  message: string;
};

export default function usePlaceDetails({ placeId }: PlacesFilter) {
  const jwt = useJwt();
  let lang = 'FR';
  if (typeof window !== undefined) {
    lang = window.config?.LANGUAGE ?? 'FR';
  }

  return useQuery<PlacesDetailsResponse, PlacesDetailsErrorResponse>(
    ['places/details', { placeId, lang, jwt }],
    {
      enabled: (placeId?.length ?? 0) > 0 && !!jwt && !!lang.length,
      retry(failureCount, error) {
        if (error.message === 'DELIVERY_COUNTRY_NOT_IN_EUROPE') {
          return false;
        }
        return failureCount < 3;
      },
    },
  );
}
